import { getDomain } from '@/utils/helpers';

let protocol = window.location.protocol;

export default {
    url: `${protocol}//${getDomain()}/api`,
    adminUrl: `${protocol}//${getDomain()}/admin`,
};